export const ActionTypes = {
    SET_PATH: "app/redux/master/SET_PATH",
    DO_TOGGLE_LOADING_SCREEN: "app/redux/master/DO_TOGGLE_LOADING_SCREEN",
    DO_FORM_SUBMIT_LOADING: "app/redux/master/DO_FORM_SUBMIT_LOADING",
}